import React from 'react';
import { motion } from 'framer-motion';
import { useParallax } from '../../hooks/useParallax';
export function BrandStory() {
  const {
    ref,
    y
  } = useParallax(50);
  return <section id="about" className="py-24 bg-white overflow-hidden" data-id="element-32">
      <div className="container mx-auto px-4" data-id="element-33">
        <div className="flex flex-col lg:flex-row items-center gap-16 max-w-7xl mx-auto" data-id="element-34">
          {/* Image Side */}
          <div className="w-full lg:w-1/2 relative h-[500px] rounded-[24px] overflow-hidden shadow-soft-lg" ref={ref} data-id="element-35">
            <motion.div style={{
            y
          }} className="absolute inset-0 -top-[10%] h-[120%] w-full" data-id="element-36">
              <div className="absolute inset-0 bg-cover bg-center" style={{
              backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/hQ88URrSofsTFTmLigxZtM/lotus-design-n-print--iQYdCr4EpE-unsplash.jpg")'
            }} data-id="element-37" />
            </motion.div>
          </div>

          {/* Text Side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full lg:w-1/2" data-id="element-38">
            <p className="text-brand-gold font-bold tracking-[0.2em] uppercase text-sm mb-4" data-id="element-39">
              Our Story
            </p>
            <h2 className="font-serif text-4xl md:text-5xl text-brand-charcoal mb-8 leading-tight" data-id="element-40">
              We Clean Like It <br className="hidden md:block" data-id="element-41" />
              <span className="font-script text-brand-blue text-5xl md:text-6xl pr-2" data-id="element-42">
                Means Something.
              </span>
            </h2>

            <div className="space-y-6 text-lg text-brand-charcoal/70 font-light mb-10" data-id="element-43">
              <p data-id="element-44">
                Maid In Heaven was born from a simple belief: your home should
                feel like a sanctuary. Not just clean, but restored. A place
                you're genuinely excited to come back to.
              </p>
              <p data-id="element-45">
                We're not a faceless cleaning service. We're a team of
                detail-obsessed professionals who care about what we do. Every
                visit is a chance to give you something worth coming home to.
              </p>
            </div>

            <a href="#team" className="inline-flex items-center text-brand-blue font-medium text-lg group" data-id="element-46">
              <span className="relative" data-id="element-47">
                Meet the Team
                <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-brand-gold transform origin-left scale-x-100 transition-transform group-hover:scale-x-0" data-id="element-48" />
              </span>
              <span className="ml-2 transform transition-transform group-hover:translate-x-1" data-id="element-49">
                →
              </span>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}